<script>
export default {
  name: "NaturaView",
  data() {
    return {
      creatures: [
        { name: "Fratello Sole", description: "Il sole illumina le nostre giornate e rappresenta la gloria di Dio" },
        { name: "Sorella Luna", description: "La luna e le stelle ornano il cielo notturno" },
        { name: "Fratello Vento", description: "Il vento porta vita e movimento al creato" },
        { name: "Sorella Acqua", description: "L'acqua è umile, preziosa e pura" },
        { name: "Fratello Fuoco", description: "Il fuoco ci riscalda e illumina nella notte" },
        { name: "Sorella Madre Terra", description: "La terra ci nutre e sostiene con i suoi frutti" }
      ]
    }
  }
}
</script>

<template>
  <h1 style="color: white">La Natura come Fratello e Sorella</h1>
  <p>
    San Francesco vede la natura non come un oggetto da sfruttare, ma come fratello e sorella. 
    Ogni creatura è degna di rispetto e amore, perché porta in sé il segno del Creatore.
  </p>
  
  <div class="arrow-spacer">
    <i class="fa fa-arrow-down"></i>
  </div>
  
  <div class="creatures-grid">
    <div class="creature-card" v-for="creature in creatures" :key="creature.name">
      <h3 style="color: white">{{ creature.name }}</h3>
      <p style="color: #9f9d9d">{{ creature.description }}</p>
    </div>
  </div>
  
  <div class="arrow-spacer">
    <i class="fa fa-arrow-down"></i>
  </div>
  
  <h1 style="color: white">Il Cantico delle Creature</h1>
  <p>
    Nel suo Cantico, Francesco loda Dio attraverso tutte le sue creature. 
    Sole, luna, stelle, vento, acqua, fuoco e terra diventano strumenti di lode al Creatore.
  </p>
  
  <div class="arrow-spacer">
    <i class="fa fa-arrow-down"></i>
  </div>
  
  <h1 style="color: white">Ecologia Francescana</h1>
  <p>
    La visione di Francesco anticipa di secoli la moderna sensibilità ecologica. 
    Il rispetto per il creato non è solo un dovere morale, ma un atto di amore verso Dio e verso i fratelli.
  </p>
  
  <div class="arrow-spacer">
    <i class="fa fa-arrow-down"></i>
  </div>
  
  <!-- Sezione Materiali di Approfondimento -->
  <div class="resources-section">
    <h2 style="color: #4caf50; font-size: 2em;">🌿 Materiali Didattici sulla Natura</h2>
    <p style="color: #dcdbdb; margin-bottom: 50px; font-size: 1.1em;">
      Attività creative e giochi educativi ispirati al rapporto di San Francesco con la natura
    </p>
    
    <div class="resources-grid">
      <!-- Dado da Costruire -->
      <div class="resource-card dado-card">
        <div class="resource-preview">
          <img src="@/assets/preview_dado.png" alt="Preview Dado" />
          <div class="preview-overlay dado-overlay">
            <i class="fa fa-cube"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>Dado della Natura</h3>
          <h4>Costruisci e Gioca</h4>
          <p>Dado da ritagliare con gli elementi della natura del Cantico delle Creature</p>
          <div class="resource-meta">
            <span><i class="fa fa-file-pdf-o"></i> PDF</span>
            <span><i class="fa fa-scissors"></i> Creativo</span>
          </div>
        </div>
        <div class="resource-actions">
          <a href="/Dado.pdf" target="_blank" class="resource-button primary-button">
            <i class="fa fa-eye"></i> Visualizza
          </a>
          <a href="/Dado.pdf" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica
          </a>
        </div>
      </div>
      
      <!-- Gioco dell'Oca -->
      <div class="resource-card oca-card">
        <div class="resource-preview">
          <img src="@/assets/preview_oca.png" alt="Preview Gioco dell'Oca" />
          <div class="preview-overlay oca-overlay">
            <i class="fa fa-gamepad"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>Gioco dell'Oca</h3>
          <h4>Percorso Francescano</h4>
          <p>Gioco da tavolo educativo sul cammino di San Francesco e il rispetto della natura</p>
          <div class="resource-meta">
            <span><i class="fa fa-file-pdf-o"></i> PDF</span>
            <span><i class="fa fa-users"></i> Multiplayer</span>
          </div>
        </div>
        <div class="resource-actions">
          <a href="/Gioco-dell-oca.pdf" target="_blank" class="resource-button primary-button">
            <i class="fa fa-eye"></i> Visualizza
          </a>
          <a href="/Gioco-dell-oca.pdf" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica
          </a>
        </div>
      </div>
      
      <!-- Segnalibro 1 -->
      <div class="resource-card bookmark-card">
        <div class="resource-preview">
          <img src="@/assets/preview_segnalibro1.png" alt="Preview Segnalibro" />
          <div class="preview-overlay bookmark-overlay">
            <i class="fa fa-bookmark"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>Segnalibro Animali</h3>
          <p>Segnalibro tematico con il lupo di Gubbio da colorare e personalizzare</p>
          <div class="resource-meta">
            <span><i class="fa fa-file-pdf-o"></i> PDF</span>
            <span><i class="fa fa-paint-brush"></i> Creativo</span>
          </div>
        </div>
        <div class="resource-actions">
          <a href="/Segnalibro.pdf" target="_blank" class="resource-button primary-button">
            <i class="fa fa-eye"></i> Visualizza
          </a>
          <a href="/Segnalibro.pdf" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica
          </a>
        </div>
      </div>
      
      <!-- Segnalibro 2 -->
      <div class="resource-card bookmark2-card">
        <div class="resource-preview">
          <img src="@/assets/preview_segnalibro2.png" alt="Preview Segnalibro 2" />
          <div class="preview-overlay bookmark2-overlay">
            <i class="fa fa-bookmark"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>Segnalibro Sole</h3>
          <p>Segnalibro tematico con la pecora, simbolo di mitezza e pace francescana</p>
          <div class="resource-meta">
            <span><i class="fa fa-file-pdf-o"></i> PDF</span>
            <span><i class="fa fa-paint-brush"></i> Creativo</span>
          </div>
        </div>
        <div class="resource-actions">
          <a href="/Segnalibro2.pdf" target="_blank" class="resource-button primary-button">
            <i class="fa fa-eye"></i> Visualizza
          </a>
          <a href="/Segnalibro2.pdf" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica
          </a>
        </div>
      </div>
      
      <!-- Giornata Mondiale del Creato -->
      <div class="resource-card pdf-card">
        <div class="resource-preview">
          <img src="@/assets/preview_giornata_mondiale_del_creato.png" alt="Preview Giornata Mondiale del Creato" />
          <div class="preview-overlay">
            <i class="fa fa-file-pdf-o"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>Giornata Mondiale del Creato</h3>
          <h4>Riflessione Ecologica</h4>
          <p>Un documento sulla celebrazione della Giornata Mondiale del Creato che collega la visione francescana alla moderna consapevolezza ambientale</p>
          <div class="resource-meta">
            <span><i class="fa fa-file-pdf-o"></i> PDF</span>
            <span><i class="fa fa-leaf"></i> Ecologia</span>
          </div>
        </div>
        <div class="resource-actions">
          <a href="/giornata_mondiale_del_creato.pdf" target="_blank" class="resource-button primary-button">
            <i class="fa fa-eye"></i> Visualizza
          </a>
          <a href="/giornata_mondiale_del_creato.pdf" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica
          </a>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Sezione Foto Attività dei Bambini -->
  <div class="activities-section">
    <h2 style="color: #4caf50; font-size: 2em;">📸 I Bambini e le Attività</h2>
    <p style="color: #dcdbdb; margin-bottom: 40px; font-size: 1.1em;">
      Momenti di creatività e apprendimento ispirati a San Francesco
    </p>
    
    <div class="photos-grid">
      <div class="photo-card">
        <img src="@/assets/Natura1.jpg" alt="Bambini con il dado" />
        <div class="photo-caption">
          <h4>Costruendo il Dado della Natura</h4>
          <p>I bambini ritagliano e assemblano il dado con gli elementi del Cantico</p>
        </div>
      </div>
      
      <div class="photo-card">
        <img src="@/assets/Natura2.jpg" alt="Colorando il segnalibro" />
        <div class="photo-caption">
          <h4>Creatività con i Segnalibri</h4>
          <p>Colorare e personalizzare i segnalibri ispirati alla natura francescana</p>
        </div>
      </div>
      
      <div class="photo-card">
        <img src="@/assets/Natura3.jpg" alt="Segnalibri completati" />
        <div class="photo-caption">
          <h4>Le Creazioni Finite</h4>
          <p>Lupo e pecora: simboli della fratellanza universale di Francesco</p>
        </div>
      </div>
      
      <div class="photo-card">
        <img src="@/assets/Natura4.jpg" alt="Attività di gruppo" />
        <div class="photo-caption">
          <h4>Apprendimento Collaborativo</h4>
          <p>Lavorare insieme per scoprire il messaggio di San Francesco</p>
        </div>
      </div>
    </div>
  </div>
  
  <div style="margin-top: 150px; height: 1px;"></div>
</template>

<style scoped>
.arrow-spacer {
  margin: 40px 0;
  color: white;
}

.creatures-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin: 40px auto;
  max-width: 900px;
}

.creature-card {
  background: #181a1c;
  padding: 20px;
  border-radius: 8px;
  transition: transform 0.3s, box-shadow 0.3s;
}

.creature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(251, 66, 66, 0.3);
}

/* Resources Section */
.resources-section {
  max-width: 1400px;
  margin: 80px auto;
  padding: 60px 20px;
  background: linear-gradient(135deg, rgba(24, 26, 28, 0.8) 0%, rgba(31, 33, 35, 0.8) 100%);
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.resources-section h2 {
  text-align: center;
  margin-bottom: 10px;
}

.resources-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin: 50px 0;
}

.resource-card {
  background: #1f2123;
  border-radius: 15px;
  padding: 0;
  transition: all 0.4s ease;
  overflow: hidden;
  border: 2px solid transparent;
  display: flex;
  flex-direction: column;
  position: relative;
}

.resource-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(90deg, #4caf50, #66bb6a);
  transform: scaleX(0);
  transition: transform 0.4s ease;
}

.resource-card:hover::before {
  transform: scaleX(1);
}

.resource-card:hover {
  transform: translateY(-15px);
  box-shadow: 0 20px 50px rgba(76, 175, 80, 0.4);
}

.dado-card:hover { border-color: #ffd93d; box-shadow: 0 20px 50px rgba(255, 217, 61, 0.4); }
.oca-card:hover { border-color: #ff6b6b; box-shadow: 0 20px 50px rgba(255, 107, 107, 0.4); }
.bookmark-card:hover { border-color: #4ecdc4; box-shadow: 0 20px 50px rgba(78, 205, 196, 0.4); }
.bookmark2-card:hover { border-color: #95e1d3; box-shadow: 0 20px 50px rgba(149, 225, 211, 0.4); }

.resource-preview {
  position: relative;
  width: 100%;
  height: 200px;
  overflow: hidden;
  background: #0d0e0f;
}

.resource-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease, filter 0.4s ease;
}

.resource-card:hover .resource-preview img {
  transform: scale(1.1);
  filter: brightness(0.7);
}

.preview-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.8), rgba(76, 175, 80, 0.3));
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.resource-card:hover .preview-overlay {
  opacity: 1;
}

.preview-overlay i {
  font-size: 4em;
  color: white;
  transform: scale(0.5);
  transition: transform 0.4s ease;
}

.resource-card:hover .preview-overlay i {
  transform: scale(1);
}

.dado-overlay {
  background: linear-gradient(135deg, rgba(255, 217, 61, 0.9), rgba(255, 217, 61, 0.4));
}

.oca-overlay {
  background: linear-gradient(135deg, rgba(255, 107, 107, 0.9), rgba(255, 107, 107, 0.4));
}

.bookmark-overlay {
  background: linear-gradient(135deg, rgba(78, 205, 196, 0.9), rgba(78, 205, 196, 0.4));
}

.bookmark2-overlay {
  background: linear-gradient(135deg, rgba(149, 225, 211, 0.9), rgba(149, 225, 211, 0.4));
}

.resource-content {
  padding: 30px;
  flex-grow: 1;
  text-align: center;
}

.resource-content h3 {
  color: #4caf50;
  font-size: 1.5em;
  margin: 0 0 5px 0;
  font-weight: bold;
}

.resource-content h4 {
  color: #dcdbdb;
  font-size: 1em;
  margin: 0 0 15px 0;
  font-weight: normal;
}

.resource-content p {
  color: #9f9d9d;
  line-height: 1.6;
  margin: 0 0 20px 0;
}

.resource-meta {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

.resource-meta span {
  background: rgba(76, 175, 80, 0.2);
  color: #81c784;
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 0.85em;
  display: flex;
  align-items: center;
  gap: 5px;
}

.resource-actions {
  display: flex;
  gap: 10px;
  padding: 20px;
  background: rgba(0, 0, 0, 0.2);
  border-top: 1px solid rgba(76, 175, 80, 0.1);
}

.resource-button {
  flex: 1;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-weight: bold;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.95em;
}

.primary-button {
  background: linear-gradient(135deg, #4caf50, #66bb6a);
  color: white;
}

.primary-button:hover {
  background: linear-gradient(135deg, #66bb6a, #81c784);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(76, 175, 80, 0.4);
}

.secondary-button {
  background: rgba(76, 175, 80, 0.2);
  color: #81c784;
  border: 2px solid rgba(76, 175, 80, 0.4);
}

.secondary-button:hover {
  background: rgba(76, 175, 80, 0.3);
  border-color: #4caf50;
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .resources-grid {
    grid-template-columns: 1fr;
  }
  
  .resource-actions {
    flex-direction: column;
  }
  
  .resource-button {
    width: 100%;
  }
  
  .photos-grid {
    grid-template-columns: 1fr;
  }
}

/* Activities Section */
.activities-section {
  max-width: 1400px;
  margin: 80px auto;
  padding: 60px 20px;
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.1) 0%, rgba(46, 125, 50, 0.1) 100%);
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.photos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin: 40px 0;
}

.photo-card {
  background: #1f2123;
  border-radius: 15px;
  overflow: hidden;
  transition: all 0.4s ease;
  border: 2px solid transparent;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.photo-card:hover {
  transform: translateY(-10px);
  border-color: #4caf50;
  box-shadow: 0 15px 30px rgba(76, 175, 80, 0.4);
}

.photo-card img {
  width: 100%;
  height: 250px;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.photo-card:hover img {
  transform: scale(1.1);
}

.photo-caption {
  padding: 20px;
  text-align: left;
}

.photo-caption h4 {
  color: #4caf50;
  margin: 0 0 10px 0;
  font-size: 1.2em;
}

.photo-caption p {
  color: #9f9d9d;
  margin: 0;
  line-height: 1.5;
}

.placeholder-preview {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.1) 0%, rgba(76, 175, 80, 0.05) 100%);
  color: #4caf50;
}

.placeholder-preview i {
  font-size: 4em;
  margin-bottom: 10px;
  opacity: 0.7;
}

.placeholder-preview p {
  margin: 0;
  font-size: 0.9em;
  font-weight: 600;
  text-align: center;
  opacity: 0.6;
}
</style>
